<template>
  <v-container>
    <alert :type="alertType" @closealert="closeAlert" :alertShow="alertShow" :msg="alertMsg"></alert>
    <template v-if="loading">
      <v-row justify="center">
        <v-col>
          <div class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-card>
        <v-list>
          <template v-for="(user, index) in users">
            <v-list-item :key="user.id">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-list-item-title>
                      <v-icon left>person</v-icon>
                      {{user.username}}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-list-item-title>
                      <v-icon left>mail</v-icon>
                      {{user.mail}}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-chip
                      v-for="scope in user.deviceTypePermission.scopes"
                      :key="scope"
                      class="mt-2 mr-1"
                      :color="scopeColor(scope)"
                      text-color="white"
                      small
                    >{{scope}}</v-chip>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <permissions-dialog
                      :scopes="user.deviceTypePermission.scopes"
                      :userId="user.id"
                      :deviceTypeId="deviceTypeId"
                      @permissionsupdated="permissionsupdated"
                      @error="error"
                    ></permissions-dialog>
                  </v-col>
                </v-row>
              </v-list-item-content>

              <v-btn
                :disabled="creatorInScopes(user.deviceTypePermission.scopes)"
                class="ml-5"
                :id="user.id"
                icon
                @click="deleteUser"
              >
                <v-icon v-if="!creatorInScopes(user.deviceTypePermission.scopes)">delete</v-icon>
              </v-btn>
            </v-list-item>
            <v-divider :key="index" v-if="index<users.length -1"></v-divider>
          </template>
        </v-list>
      </v-card>
    </template>

    <v-row align="center">
      <v-col class="text-center">
        <v-form v-model="validUser">
          <v-text-field
            v-model="userToAddName"
            :label="$t('DeviceTypes.add-username')"
            name="add user with username"
            prepend-icon="person"
            type="text"
            :append-icon="'mdi-plus-circle'"
            @click:append="addUserWithUsername"
            required
          ></v-text-field>
        </v-form>
        <v-form v-model="validMail">
          <v-text-field
            v-model="userToAddMail"
            :rules="[rules.validateEmail]"
            :label="$t('DeviceTypes.add-mail')"
            name="add user with mail"
            prepend-icon="mail"
            type="email"
            :append-icon="'mdi-plus-circle'"
            @click:append="addUserWithMail"
            required
          ></v-text-field>
        </v-form>
      </v-col>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DeviceTypes.back')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

import AlertComponent from "./Alert.vue";
import PermissionsComponent from "./PermissionsDialogComponent";

export default {
  components: {
    alert: AlertComponent,
    "permissions-dialog": PermissionsComponent
  },
  props: {
    choosenDeviceType: Object
  },
  data: () => ({
    users: [],
    userToAddName: "",
    userToAddMail: "",
    userToAddId: null,
    validUser: false,
    validMail: false,
    alertMsg: "",
    alertType: "error",
    alertShow: false,
    loading: true,
    rules: {
      required: value => !!value || "Required.",
      validateEmail: value => {
        var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
        return (
          value.length == 0 ||
          re.test(String(value).toLowerCase()) ||
          "Bad mail format"
        );
      }
    }
  }),
  computed: {
    deviceTypeId: function() {
      return this.choosenDeviceType.deviceTypeId;
    }
  },
  methods: {
    creatorInScopes: function(scopes) {
      return (
        scopes.findIndex(scope => {
          return scope == "creator";
        }) >= 0
      );
    },
    error: function(value) {
      this.alertMsg = value;
      this.alertType = "error";
      this.alertShow = true;
    },
    saved: function(value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
    },
    closeAlert: function() {
      this.alertShow = false;
    },
    deleteUser: function(event) {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR +
            "/api/user/" +
            event.currentTarget.id +
            "/devicetype/" +
            this.deviceTypeId,

          {
            headers: { Authorization: tokenStore.getToken() }
          }
        )
        .then(res => {
          if (res.data.success) {
            this.userToAddId = null;
            this.userToAddMail = "";
            this.userToAddName = "";
            load(this);
            this.saved(this.$t("DeviceTypes.Alert.success-remove-user"));
          } else {
            this.error(this.$t("DeviceTypes.Alert.form-error"));
          }
        })
        .catch(err => {
          if (err) {
            this.error(err.response.data.errorMessage);
          }
        });
    },
    addUser: function(userId) {
      axios
        .put(
          process.env.VUE_APP_API_ADDR +
            "/api/user/" +
            userId +
            "/devicetype/" +
            this.deviceTypeId,
          {
            scopes: []
          },
          {
            headers: { Authorization: tokenStore.getToken() }
          }
        )
        .then(res => {
          if (res.data.success) {
            this.userToAddId = null;
            this.userToAddMail = "";
            this.userToAddName = "";
            load(this);
            this.saved(this.$t("DeviceTypes.Alert.success-add-user"));
          } else {
            this.error(this.$t("DeviceTypes.Alert.form-error"));
          }
        })
        .catch(err => {
          if (err) {
            this.error(err.response.data.errorMessage);
          }
        });
    },
    addUserWithUsername: function() {
      if (!this.validUser || this.userToAddName == "") {
        this.error(this.$t("DeviceTypes.Alert.miss-username"));
      } else {
        axios
          .get(process.env.VUE_APP_API_ADDR + "/api/user", {
            headers: { Authorization: tokenStore.getToken() }
          })
          .then(res => {
            if (res.data.success) {
              res.data.users.forEach(user => {
                if (user.username == this.userToAddName) {
                  this.userToAddId = user.id;
                }
              });
              if (this.userToAddId != null) {
                this.addUser(this.userToAddId);
              } else {
                this.error(this.$t("DeviceTypes.Alert.username-error"));
              }
            } else {
              this.error(this.$t("DeviceTypes.Alert.form-error"));
            }
          })
          .catch(err => {
            if (err) {
              this.error(err.response.data.errorMessage);
            }
          });
      }
    },
    addUserWithMail: function() {
      if (!this.validMail || this.userToAddMail == "") {
        this.error(this.$t("DeviceTypes.Alert.miss-mail"));
      } else {
        axios
          .get(process.env.VUE_APP_API_ADDR + "/api/user", {
            headers: { Authorization: tokenStore.getToken() }
          })
          .then(res => {
            if (res.data.success) {
              res.data.users.forEach(user => {
                if (user.mail == this.userToAddMail) {
                  this.userToAddId = user.id;
                }
              });

              if (this.userToAddId != null) {
                this.addUser(this.userToAddId);
              } else {
                this.error(this.$t("DeviceTypes.Alert.mail-error"));
              }
            } else {
              this.error(this.$t("DeviceTypes.Alert.form-error"));
            }
          })
          .catch(err => {
            if (err) {
              this.error(err.response.data.errorMessage);
            }
          });
      }
    },
    permissionsupdated: function() {
      this.userToAddId = null;
      this.userToAddMail = "";
      this.userToAddName = "";
      load(this);
      this.saved(this.$t("DeviceTypes.Alert.success-permissions"));
    },
    scopeColor: function(scope) {
      switch (scope) {
        default:
          return "primary";

        case "admin":
          return "red";

        case "creator":
          return "#981b00";
      }
    }
  },
  beforeMount: function() {
    load(this);
  }
};

function load(el) {
  el.users = [];
  axios
    .get(
      process.env.VUE_APP_API_ADDR +
        "/api/devicetype/" +
        el.deviceTypeId +
        "/users",
      {
        headers: { Authorization: tokenStore.getToken() }
      }
    )
    .then(res => {
      if (res.data.success) {
        res.data.users.forEach(userId => {
          axios
            .get(process.env.VUE_APP_API_ADDR + "/api/user/" + userId, {
              headers: { Authorization: tokenStore.getToken() }
            })
            .then(res => {
              if (res.data.success) {
                let $user = JSON.parse(JSON.stringify(res.data.user));
                $user.deviceTypePermission =
                  $user.permissions.deviceTypes[
                    $user.permissions.deviceTypes.findIndex(devType => {
                      return devType.deviceTypeId == el.deviceTypeId;
                    })
                  ];
                el.users.push($user);
              }
            })
            .catch(err => {
              el.error(err.response.data.errorMessage);
            });
        });
        el.loading = false;
      }
    })
    .catch(err => {
      el.error(err.response.data.errorMessage);
    });
}
</script>